import { secondsToReadableTime } from "@forwardflow/helpers/utils"

export const CurrentConversionStats = ({
   conversionRatePercent,
   avgSpeedToAction,
   responseRatePercent,
}: {
   conversionRatePercent: number
   avgSpeedToAction: number
   responseRatePercent: number
}) => {
   return (
      <div className="bg-[#3B3C42] mb-4 rounded">
         <p className="px-8 py-5 border-b border-white/20">
            Current Conversion stats
         </p>

         <div className="flex flex-wrap">
            <div className="flex-1 py-5 px-7">
               <p className="text-white/70 text-[14px] font-medium mb-1">
                  Conversations
               </p>
               <div className="flex items-center gap-x-2">
                  <span className="text-[24px] font-medium">
                     {conversionRatePercent} %
                  </span>
               </div>
            </div>

            <div className="flex-1 py-5 px-7">
               <p className="text-white/70 text-[14px] font-medium mb-1">
                  Speed to Action
               </p>
               <div className="flex items-center gap-x-2">
                  <span className="text-[24px] font-medium">
                     {secondsToReadableTime(
                        avgSpeedToAction ?? 0
                     )}
                  </span>
               </div>
            </div>

            <div className="flex-1 py-5 px-7">
               <p className="text-white/70 text-[14px] font-medium mb-1">
                  Responses
               </p>
               <div className="flex items-center gap-x-2">
                  <span className="text-[24px] font-medium">
                     {responseRatePercent} %
                  </span>
               </div>
            </div>
         </div>
      </div>
   )
}
